// extracted by mini-css-extract-plugin
export default {"steps":"AssessmentPage_steps__FleXP","empty":"AssessmentPage_empty__mcMmv","result":"AssessmentPage_result__N1uxj","image":"AssessmentPage_image__FBZAb"};